import 'angular';

import { ASSEMBLY_PAYMENT_STATUSES }          from './assembly-payment.statuses.constant.ajs';
import { AssemblyPaymentsPairCtrl }           from './assembly-payments.pair.ajs';
import { AssemblyPaymentsService }            from './assembly-payments.service.ajs';
import { AssemblyPaymentsSettingsCtrl }       from './assembly-payments.settings.ajs';
import { AssemblyPaymentsStates }             from './assembly-payments.states.ajs';
import { AssemblyPaymentsTerminalsCtrl }      from './assembly-payments.terminals.ajs';
import { AssemblyPaymentsTerminalsDirective } from './assembly-payments.terminals.directive.ajs';

angular.module('workshop.assembly-payments', [])
  .config(AssemblyPaymentsStates)
  .constant('ASSEMBLY_PAYMENT_STATUSES', ASSEMBLY_PAYMENT_STATUSES)
  .controller('AssemblyPaymentsPairCtrl', AssemblyPaymentsPairCtrl)
  .controller('AssemblyPaymentsSettingsCtrl', AssemblyPaymentsSettingsCtrl)
  .controller('AssemblyPaymentsTerminalsCtrl', AssemblyPaymentsTerminalsCtrl)
  .directive('assemblyPaymentsTerminals', AssemblyPaymentsTerminalsDirective)
  .service('assemblyPaymentsApi', AssemblyPaymentsService);
